module.exports = __webpack_public_path__ + "static/media/CF.6703904b.svg";